import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { colors } from '../../constants/theme';
import LoadingSpinner from '../Common/LoadingSpinner';
import ErrorMessage from '../Common/ErrorMessage';

const OrganizerLogin = ({ onLogin, onSwitchToSpectator, error, loading }) => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });

  const handleLogin = async (e) => {
    e.preventDefault();
    if (credentials.username && credentials.password) {
      await onLogin(credentials);
    }
  };

  if (loading) {
    return <LoadingSpinner text="Fazendo login..." />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: colors.primary }}>
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="text-center mb-6">
          <Shield className="mx-auto h-12 w-12 mb-4" style={{ color: colors.primary }} />
          <h2 className="text-2xl font-bold" style={{ color: colors.primary }}>
            Acesso do Organizador
          </h2>
        </div>

        {error && (
          <ErrorMessage message={error} className="mb-4" />
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Usuário</label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
              style={{ focusRingColor: colors.primary }}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Senha</label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2"
              style={{ focusRingColor: colors.primary }}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 rounded-md text-white font-medium hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: colors.primary }}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={onSwitchToSpectator}
            className="text-sm hover:underline"
            style={{ color: colors.primary }}
          >
            Ver como espectador
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrganizerLogin;